import { get } from '@saas/service-api/src/request'

export function getH5Report(token) {
  return get(`/v1/report/h5/${token}`)
}
